import { LayoutPlaceholder } from "components/Layout/LayoutPlaceholder";
import { useCallback } from "react";
import * as vscode from "vscode";

import { CustomEditor } from "../CommonVSCode/CustomEditor";

export const NewDevtoolEditor = () => {
  const getName = useCallback(() => {
    return "New Devtool";
  }, []);

  const getIcon = useCallback(() => {
    return "plus";
  }, []);

  return (
    <CustomEditor
      Component={LayoutPlaceholder}
      getIcon={getIcon}
      getName={getName}
      globPattern="csb-new-tab:/**"
      id="codesandbox.editors.codesandbox-new-tab"
      name="New Devtool"
      paneLabel="New CodeSandbox Devtool"
      serializer={{
        serialize(_editor) {
          return "new";
        },
        deserialize(_instantiationService, _serializedEditor) {
          return vscode.Uri.from({
            scheme: "csb-new-tab",
            path: "/",
          });
        },
      }}
    ></CustomEditor>
  );
};
